import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { embedSearchWidgetViewVolopRoute } from '#/modules/embedSearchWidget/routing/embedSearchWidget.routes';
import type { SearchAlgoliaHit } from '#/modules/search/algolia/types/SearchAlgoliaHit';

type Args = {
  result: SearchAlgoliaHit;
  embedSearchWidgetId: ApiEmbedSearchWidgetId | null;
  locale: I18nLocale;
};

export function searchContextHeaderGetUrl({
  result,
  embedSearchWidgetId,
  locale,
}: Args) {
  if (embedSearchWidgetId) {
    return embedSearchWidgetViewVolopRoute.with({
      lang: locale,
      embedSearchWidgetId,
      volopId: result.objectID,
    });
  }

  if (result.type === 'IMPORTED') {
    const source = result.source
      ? result.source.replace(/_/g, '-').toLowerCase()
      : '';

    return `/${locale}/imported-action-opps/${source}/${result.objectID.replace(
      `${result.source}_`,
      '',
    )}`;
  }

  if (typeof result.url === 'string') return result.url;

  return result.url[locale];
}
